import type {
	ClientPortfolioDetailToolsResponseDTO,
	ClientPortfolioInvestmentCreateRequestDTO,
	ClientPortfolioInvestmentEditRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type {
	InvestmentCreateFormOutput,
	InvestmentEditFormOutput,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";
import { mapInvestmentToolsToRequest } from "web_myplann/Portfolio/Forms/InvestmentForm/Mappers/mapInvestmentToolsToRequest";
import { mapManualValueToRequest } from "web_myplann/Portfolio/PortfolioShared/ManualValue/mapManualValueToRequest";

export const mapInvestmentCreateFormToRequest = (
	data: InvestmentCreateFormOutput,
): Omit<ClientPortfolioInvestmentCreateRequestDTO, "productCategory"> => {
	const { tools, value, invested, valueDate, ...contract } = data;
	return {
		...contract,
		manualValue: mapManualValueToRequest({ value, invested, valueDate }),
		tools: mapInvestmentToolsToRequest(tools),
	};
};

export const mapInvestmentEditFormToRequest = (
	data: Partial<InvestmentEditFormOutput>,
	originalTools: ClientPortfolioDetailToolsResponseDTO | null | undefined,
): Partial<
	Omit<ClientPortfolioInvestmentEditRequestDTO, "productCategory">
> => {
	const { tools, ...contract } = data;
	return tools
		? { ...contract, tools: mapInvestmentToolsToRequest(tools, originalTools) }
		: contract;
};
